module.exports = "/_next/static/images/05-3b6aed7b3e5e86f596c30ef357f271fc.png";